import { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';
import { useUpdateNexusPlugin } from './useNexusPlugins';

/**
 * Plugin-Config-Editor: rohes JSON-Edit für plugins.config.
 *
 * Plugin-spezifische Schemas leben in Nexus (src/plugins/[kind]/[id]/index.js).
 * Orbit zeigt das JSON pretty-printed; Server validiert via Plugin-Schema.
 */
export function PluginConfigModal({ plugin, onClose }) {
  const [jsonText, setJsonText] = useState(() =>
    JSON.stringify(plugin.config ?? {}, null, 2),
  );
  const [error, setError] = useState(null);
  const update = useUpdateNexusPlugin();
  const busy = update.isPending;

  const onSubmit = async (e) => {
    e.preventDefault();
    let parsed;
    try {
      parsed = JSON.parse(jsonText);
    } catch (err) {
      setError('JSON-Fehler: ' + (err?.message ?? 'unbekannt'));
      return;
    }
    try {
      await update.mutateAsync({ id: plugin.identifier, patch: { config: parsed } });
      onClose();
    } catch (err) {
      setError(err?.data?.message ?? err?.message ?? 'Speichern fehlgeschlagen.');
    }
  };

  return (
    <Modal isOpen toggle={busy ? undefined : onClose} size="lg" backdrop="static">
      <Form onSubmit={onSubmit}>
        <ModalHeader toggle={busy ? undefined : onClose}>
          {plugin.identifier} · Config (JSON)
        </ModalHeader>
        <ModalBody>
          <Alert color="info" className="small">
            Nexus validiert die Config gegen das Plugin-Schema in{' '}
            <code>src/plugins/{plugin.identifier.split('-')[0]}/{plugin.identifier}/index.js</code>.
            Bei Schema-Verletzung → 400 mit Detail-Message.
          </Alert>
          <FormGroup className="mb-0">
            <Label>JSON</Label>
            <Input
              type="textarea"
              rows={14}
              value={jsonText}
              onChange={(e) => {
                setJsonText(e.target.value);
                setError(null);
              }}
              className="font-monospace"
              style={{ fontSize: 13 }}
              disabled={busy}
            />
          </FormGroup>
          {error && <Alert color="danger" className="mt-2 mb-0 small">{error}</Alert>}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={onClose} disabled={busy}>
            Abbrechen
          </Button>
          <Button color="primary" type="submit" disabled={busy}>
            {busy ? 'Speichern…' : 'Config speichern'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
